import React, { useContext } from 'react';
import { ContextBuilder } from '../../../context/builder/reducers';
import Tiny from '../../TinyMce';
import Select from './Select';

const TinyMce = (props) => {
  const { state, dispatch } = useContext(ContextBuilder);

  const handleEditorChange = (props, content) => {
    if (props.onChange) {
      props.onChange(props.index, props.name, content);
    } else {
      const data = state.data;
      data.value[props.index].content = content;
      dispatch({ type: 'data', payload: { data: data } });
    }
  };

  return (
    <div>
      <Tiny {...{ ...props, handleEditorChange }} />
    </div>
  );
};

export default TinyMce;
